import { NgClass } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';

type TooltipHorizontalAlignment = 'left' | 'center' | 'right';

@Component({
  selector: 'aw-tooltip',
  imports: [NgClass],
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent {
  public readonly text: InputSignal<string> = input.required<string>();
  public readonly showIcon: InputSignal<boolean> = input<boolean>(true);
  public readonly hoverDelayMs: InputSignal<number> = input<number>(0);
  public readonly horizontalAlignment: InputSignal<TooltipHorizontalAlignment> =
    input<TooltipHorizontalAlignment>('center');
  public readonly ariaLabel: InputSignal<string> = input<string>(
    'Beschreibung anzeigen'
  );
}
